import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslation } from '@/hooks/useTranslation';
import { useCompanyProfile } from '../hooks/useCompanyProfile';
import { CreateToolForm } from './CreateToolForm';
import { keepOpenWhileListOpen } from './pickers/keepOpenWhileListOpen';

type AddToolModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (toolId: string) => void;
  /** ID to start from ("Créer cet outil" on an unknown ID). */
  initialToolId?: string;
};

export const AddToolModal: React.FC<AddToolModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  initialToolId,
}) => {
  const { t } = useTranslation();
  const { companyName, companyAutoFilled } = useCompanyProfile();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-lg" onEscapeKeyDown={keepOpenWhileListOpen}>
        <DialogHeader>
          <DialogTitle>{t('traceability.addToolModal.title')}</DialogTitle>
          <DialogDescription>{t('traceability.addToolModal.description')}</DialogDescription>
        </DialogHeader>
        <CreateToolForm
          companyName={companyName}
          companyAutoFilled={companyAutoFilled}
          initialToolId={initialToolId}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
};
